import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-index',
  templateUrl: './contact-index.component.html',
  styleUrls: ['./contact-index.component.css']
})
export class ContactIndexComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
